export namespace PDFUtils {
  export const normalizeProductTitle = (title: string) => title.replace(/review/i, '').trim();
  // TODO
  export const calcUTCTime = () => {
    throw new Error('TODO');
  };
}
